import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import ReactModal from 'react-modal';
import Media from 'react-media';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { currentProjectIdSelector } from '../../../reducers/projects';
import { RelationshipActions } from '../../../actions/relationship';
import { validateAndDispatch } from '../../../helpers/form';
import WbsLayout from '../../WbsLayout/';
import TasksList from './TasksList';
import Predecessors from './Predecessors';
import {
  taskTypeIdSelector,
  milestoneTypeIdSelector,
} from '../../../reducers/elementTypes';

// This modal component does not work the same as the way the FullScreenModal works.
// See app/components/types.RelationshipSelect/Display.js to see how to implement this
// react-modal based component.

const currentElementIdSelector = (state, props) => props.currentElementId;

const elementsRelationshipsSelector = state =>
  state.elementsRelationships.get('elementsRelationships');

const elementSelector = (state, props) => {
  const currentElementId = currentElementIdSelector(state, props);
  return currentElementId
    ? state.elements.getIn(['elements', currentElementId])
    : null;
};

const elementsSelector = state => state.elements.get('elements');

const elementTypeSelector = (state, props) => {
  const currentElementId = currentElementIdSelector(state, props);

  const testing = state.elements.getIn([
    'elements',
    currentElementId,
    'type_id',
  ]);
  const current = testing
    ? state.elementTypes.getIn(['elementTypes', testing.toString()])
    : null;

  return currentElementId && current ? current : null;
};

const consumesFromSelector = (state, props) => {
  const consumesFrom = elementsRelationshipsSelector(state).getIn(
    [currentElementIdSelector(state, props), 'consumesFrom'],
    List(),
  );
  return Map({
    consumesFrom,
  });
};

const AssignPredecessorsSelector = immutableCreatorSelector(
  [
    currentProjectIdSelector,
    currentElementIdSelector,
    elementsRelationshipsSelector,
    taskTypeIdSelector,
    milestoneTypeIdSelector,
    elementSelector,
    elementsSelector,
    elementTypeSelector,
    consumesFromSelector,
  ],
  (
    currentProjectId,
    currentElementId,
    elementsRelationships,
    taskTypeId,
    milestoneTypeId,
    element,
    elements,
    elementType,
    consumesFrom,
  ) => ({
    currentProjectId,
    currentElementId,
    elementsRelationships,
    taskTypeId,
    milestoneTypeId,
    element,
    elements,
    elementType,
    consumesFrom,
  }),
);

@connect(AssignPredecessorsSelector)
export default class AssignPredecessorsModal extends Component {
  static propTypes = {
    contentLabel: PropTypes.string,
    showModal: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    rootElementId: PropTypes.string,
    elementTypes: PropTypes.instanceOf(Map),
    elements: PropTypes.instanceOf(Map),
    relationships: PropTypes.instanceOf(Map),
    wbsRootElementId: PropTypes.string,
    elementType: PropTypes.instanceOf(Map),
    currentElementId: PropTypes.string,
    typeId: PropTypes.string,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    tasklistCallback: PropTypes.func,
    consumesFrom: PropTypes.instanceOf(Map),
    inlineTypeOptions: PropTypes.object,
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func,
    existingPredecessors: PropTypes.array,
    relationshipDirection: PropTypes.string,
    relationshipType: PropTypes.string,
  };

  handleAddRel = async x => {
    const {
      dispatch,
      currentElementId,
      currentProjectId,
      relationshipDirection,
      relationshipType,
    } = this.props;

    const producers = this.existingRelationships();
    const existingPredecessors = producers.map(p => p.get('id'));
    const otherElementIds = existingPredecessors.push(x.get('id')).toArray();
    // debugger;
    const action = RelationshipActions.patchRelationships(
      {
        relationshipDirection,
        relationshipType,
        elementId: currentElementId,
        otherElementIds,
        strength: 1,
      },
      currentProjectId,
    );

    await validateAndDispatch(dispatch, action, {}, {});
  };

  existingRelationships = () => {
    const {
      consumesFrom,
      relationships,
      elements,
      taskTypeId,
      milestoneTypeId,
    } = this.props;
    const predecessorRelIds = consumesFrom.getIn(['consumesFrom'], []);

    return predecessorRelIds
      .filter(relId => {
        const relElementId = relationships.getIn([relId, 'producer']);
        const element = elements.get(relElementId);
        return (
          element.get('type_id') === taskTypeId ||
          element.get('type_id') === milestoneTypeId
        );
      })
      .map(relId => {
        const relProps = relationships.getIn([relId, 'props']);
        const relElementId = relationships.getIn([relId, 'producer']);
        const element = elements.get(relElementId);
        return element.set('relProps', relProps);
      });
  };

  render() {
    const {
      dispatch,
      showModal,
      contentLabel,
      handleCloseModal,
      elementType,
      elements,
      elementIds,
      multiEditElementType,
      currentElementId,
      currentProjectId,
      relationshipDirection,
      relationshipType,
      tasklistCallback,
    } = this.props;

    const producers = this.existingRelationships();
    const existingPredecessors = producers.map(x => x.get('id'));
    const existingRelationshipsArray = existingPredecessors.toArray();
    const elementName = elements.getIn([currentElementId, 'name']);
    return (
      <Media query="(max-width: 992px)">
        {matches => (
          <ReactModal
            isOpen={showModal}
            contentLabel={contentLabel}
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                overflowY: 'auto',
              },
              content: {
                marginLeft: 'auto',
                marginRight: 'auto',
                padding: 0,
                border: 'none',
                bottom: 'auto',
                borderRadius: 4,
                maxWidth: matches ? '90vw' : '60vw',
              },
            }}
          >
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#eee' }}>
                <h5 className="modal-title">Assign Predecessors</h5>
                <button
                  onClick={handleCloseModal}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i
                    className="fa fa fa-times"
                    style={{ fontSize: '1.3em', color: '#808080' }}
                  />
                </button>
              </div>
              <div className="modal-body" style={{ fontFamily: 'Arial' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      padding: '0 .75em .25em .75em',
                      marginBottom: 0,
                      fontFamily: 'Arial',
                      fontSize: 20,
                      fontWeight: 700,
                    }}
                  >
                    {elementName}
                  </div>
                  <div style={{ display: 'flex' }}>
                    <WbsLayout>
                      <TasksList
                        elementType={elementType}
                        selectedElementId={currentElementId}
                        elementIds={elementIds}
                        multiEditElementType={multiEditElementType}
                        existingPredecessors={existingRelationshipsArray}
                        tasklistCallback={tasklistCallback}
                        handleAddRel={this.handleAddRel}
                      />
                    </WbsLayout>
                    <div style={{ width: '50%' }}>
                      <h2 style={{ fontSize: 18, fontWeight: 700 }}>
                        Predecessors
                      </h2>
                      <Predecessors
                        producers={producers}
                        dispatch={dispatch}
                        currentElementId={currentElementId}
                        existingRelationshipsArray={existingRelationshipsArray}
                        currentProjectId={currentProjectId}
                        relationshipDirection={relationshipDirection}
                        relationshipType={relationshipType}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal-footer"
                style={{ backgroundColor: '#eee', padding: 0 }}
              >
                <button
                  className="btn btn-primary modal-submit-btn"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </ReactModal>
        )}
      </Media>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AssignPredecessorModal/index.js